// packages/data/src/lock-unlock.ts
import { __dangerousOptInToUnstableAPIsOnlyForCoreModules } from "@wordpress/private-apis";
var { lock, unlock } = __dangerousOptInToUnstableAPIsOnlyForCoreModules(
  "I acknowledge private features are not for use in themes or plugins and doing so will break in the next version of WordPress.",
  "@wordpress/data"
);
export {
  lock,
  unlock
};
//# sourceMappingURL=lock-unlock.js.map
